/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3945 Freedom Circle, Suite 730 Santa Clara, CA 95054
 * All rights reserved.
 */

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useDashboardData, useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import { getDataForCustomVizWidget } from '../../../features/widget/asyncThunks'

const useCustomVizWidgetData = (widgetId) => {
  const widgetSetting = useDashboardWidgetSetting(widgetId)
  const { dashboardId, name } = useDashboardData()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      getDataForCustomVizWidget({
        widgetId: widgetSetting.widgetId
      })
    )
  }, [widgetSetting, dashboardId, name, dispatch])
}

const CustomVizWidgetDataEffect = ({ widgetId, children }) => {
  useCustomVizWidgetData(widgetId)
  return children
}

export default CustomVizWidgetDataEffect
